/**
 * Utility functions for share URL restoration
 */

// Global flag to indicate share URL restoration is in progress
declare global {
  interface Window {
    __SHARE_URL_RESTORING__?: boolean;
  }
}

/**
 * Check if share URL restoration is currently in progress
 * @returns boolean indicating if restoration is active
 */
export function isShareUrlRestoring(): boolean {
  return Boolean(window.__SHARE_URL_RESTORING__);
}

/**
 * Set the share URL restoration flag
 * @param restoring - whether restoration is in progress
 */
export function setShareUrlRestoring(restoring: boolean): void {
  window.__SHARE_URL_RESTORING__ = restoring;
}

/**
 * Check if auto-sizing should be skipped due to share URL restoration
 * Logs a message when skipping and returns the result
 * @returns boolean indicating if auto-sizing should be skipped
 */
export function shouldSkipAutoSizing(): boolean {
  return isShareUrlRestoring();
}
